import ManageSuperUsers from './components/ManageSuperUsers';
import { bindActionCreators } from 'redux';
import values from 'lodash/values';
import {connect} from 'react-redux';

import { loadProviders,updateUser } from '../../shared/redux/entities/actions'

function mapStateToProps(state){
  return {
    users:values(state.entities.users).filter((u) => u.isProvider)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ loadProviders,updateUser },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(ManageSuperUsers);



// WEBPACK FOOTER //
// ./src/routes/ManageSuperUsers/index.js